import { CustomerOffers } from "@expert/sales-tools";
import { Flex } from "@mantine/core";

import { ProductSaleFlowPanel } from "@/sales-tools/product-sale-flow/ProductSaleFlowPanel";
import { useProductSaleFlow } from "@/sales-tools/product-sale-flow/useProductSaleFlow";

import styles from "./SidecarTabPanel.module.css";

/**
 * Right-top "Offers" tab content; swaps to `ProductSaleFlowPanel` inline while a sale flow is active.
 *
 * Mount discipline: the parent must not mount this outside a customer session — `CustomerOffers`
 * throws "Active task is not voice or chat task" without an active voice/chat task.
 */
export function OffersTab() {
    const { selectedProduct, handleProductSaleClose } = useProductSaleFlow();

    return (
        <Flex pos="absolute" inset={0} className={styles.scrollableRoot} data-testid="offers-right-top-tab">
            <Flex className={styles.column}>
                {selectedProduct ? (
                    <ProductSaleFlowPanel onBack={handleProductSaleClose} />
                ) : (
                    <CustomerOffers view="offers" />
                )}
            </Flex>
        </Flex>
    );
}
